import useSWR from 'swr'

import { projectUrls } from '@/config/urls/project/project'
import { get } from '@/utils/fetchers'

import { ApiPageableResponse, PageProject } from '@/types/index.d'

export type useRepositoriesParams = {
  filter?: string
  pageIndex?: number
  pageSize?: number
}

export function useRepositories(
  workspaceId: string,
  { filter, pageIndex = 0, pageSize = 5 }: useRepositoriesParams
): ApiPageableResponse<PageProject> {
  const url = projectUrls.listActiveGitProjects({
    workspaceId,
    params: {
      exclude_score: true,
      filter: filter,
      page: pageIndex,
      size: pageSize,
    },
  })

  const { data, error } = useSWR<PageProject>(
    workspaceId ? url : null,
    get(url, { filter, pageIndex, pageSize, workspaceId })
  )

  return {
    data,
    error,
    isLoading: (url && !data) || (!data.content && !error),
  }
}
